export const SearchProviderDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'SearchProvider' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'GlobalSearchDocumentMetadataQuery' },
                        directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'unmask' } }],
                    },
                    {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'GlobalSearchUsersQuery' },
                        directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'unmask' } }],
                    },
                    {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'GlobalSearchTeamsQuery' },
                        directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'unmask' } }],
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GlobalSearchDocumentMetadataQuery' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'documentMetadataProperties' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'companyId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'reference' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'allowedValues' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'groupValues' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GlobalSearchUsersQuery' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'users' },
                        name: { kind: 'Name', value: 'users2' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: {
                                    kind: 'ListValue',
                                    values: [
                                        {
                                            kind: 'ObjectValue',
                                            fields: [
                                                {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'name' },
                                                    value: { kind: 'EnumValue', value: 'asc' },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GlobalSearchTeamsQuery' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teams' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
